import {  TextField, Text } from "@radix-ui/themes";
import { t } from "i18next";
import _ from "lodash";
import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { times } from "../../../enums/times";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { FShift, Shift } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { SelectButton } from "../../../ui/SelectButton/SelectButton";
import { NavLink } from "react-router-dom";
import { TbArrowLeft } from "react-icons/tb";

const AddShift = () => {
  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      shift_name: "",
      shift_start_time: null,
      shift_end_time: null,
    },
  });

  const [{ response: itemSaveResponse, isLoading: itemSaveIsLoading, error: itemSaveError }, doFetchItemSave] =
    useFetch(`/directories/working_shifts`);

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.shift_name,
          started_at: formData.shift_start_time,
          ended_at: formData.shift_end_time,
        },
      },
    });
    reset();
  };

    const shifts = useAppStore((store) => store.shifts);
    const setShifts = useAppStore((store) => store.setShifts);

    const addShift = (itemSaveResponse: { data: unknown }) => {
      const newShiftData = itemSaveResponse.data as unknown as Shift;
      
      // Пересборка того что приходит с бэка
      let start = DateTime.fromISO(newShiftData.attributes.started_at)
      let end = DateTime.fromISO(newShiftData.attributes.ended_at)
      let build_start = DateTime.fromObject({year: 2000, month: 1, day: 1, hour: start.hour, minute: start.minute, second: start.second})
      let build_end = DateTime.fromObject({year: 2000, month: 1, day: 1, hour: end.hour, minute: end.minute, second: end.second})

      const ShiftData = {
        id: newShiftData.id,
        name: newShiftData.attributes.name,
        start_at: build_start,
        end_at: build_end,
      } as unknown as FShift;
      setShifts([...shifts, ShiftData]);
    };

  useEffect(() => {
    if (!itemSaveResponse) return
    addShift(itemSaveResponse!);
  }, [itemSaveResponse]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/shifts"} className="text-sm flex gap-2 items-center text-muted-foreground hover:text-primary"><TbArrowLeft />{t("shifts")}</NavLink>
            <span className="text-2xl font-semibold">{t('adding_shift')}</span>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="px-6">
          <div className="flex flex-col w-full h-full gap-2">
            <Controller
              name="shift_name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("shift_name")}*`} />
                </div>
              )}
            />
            <Controller
              name="shift_start_time"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("shift_start_time")}*</Label>
                  <SelectButton
                    label={"Выберите время"}
                    searchable={true}
                    options={times}
                    value={value ? times.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />
            <Controller
              name="shift_end_time"
              control={control}
              render={({ field: { value, onChange } }) => (
                <div className="relative space-y-2">
                  <Label>{t("shift_end_time")}*</Label>
                  <SelectButton
                    label={"Выберите время"}
                    searchable={true}
                    options={times}
                    value={value ? times.find((s) => s.value == String(value))! : null}
                    onChange={(e) => onChange(e?.value)}
                  />
                </div>
              )}
            />
            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddShift;
